import * as diffDays from 'date-fns/difference_in_calendar_days';
import * as addDays from 'date-fns/add_days';
import * as formatDate from 'date-fns/format';

import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';

import { parseDateString } from './parsers';
import { DepartureDatesModel, NightsModel } from '../stores/search-form';


export function getInitialNumAdults(): number | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.adults;
}

export function getInitialKidsAges(): Array<number> | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.kidsAges;
}

export function getInitialDepartureDateFrom(): string | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.departureDateFrom;
}

export function getInitialDepartureDateTo(): string | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.departureDateTo;
}

export function getInitialDepartureDate(): DepartureDatesModel | null {
    const initialDateFrom = getInitialDepartureDateFrom();
    const initialDateTo = getInitialDepartureDateTo();

    if (!initialDateFrom || !initialDateTo) {
        return null;
    }

    let dateFrom = parseDateString(initialDateFrom);
    let dateTo = parseDateString(initialDateTo);
    const days = diffDays(dateTo!, dateFrom!);

    return {
        date: formatDate(addDays(dateFrom!, Math.ceil(days / 2)), 'DD.MM.YYYY'),
        dateIntervalChecked: initialDateFrom !== initialDateTo
    };
}

export function getInitialDepartureCityId(): number | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.departureCityId;
}

function getInitialNightsMin(): number | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.nightsMin;
}

function getInitialNightsMax(): number | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.nightsMax;
}

export function getInitialSelectedSources(): number[] {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams?.selectedSources) {
        return [];
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.selectedSources.split(',').map((s: string) => (+s));
}

export function getInitialNights(): NightsModel | null {
    const initialNightsMin = getInitialNightsMin();
    const initialNightsMax = getInitialNightsMax();

    if (!initialNightsMin || !initialNightsMax) {
        return null;
    }

    return {
        min: initialNightsMin,
        max: initialNightsMax
    };
}

export function getInitialTicketsIncluded(): boolean {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return true;
    }
    return window.__INITIAL_STATE__.pageModel.searchRequestParams.isTicketsIncluded;
}

export function getInitialMealsIds(): string[] | null {
    if (!canUseDOM || !window.__INITIAL_STATE__.pageModel.searchRequestParams) {
        return null;
    }

    return window.__INITIAL_STATE__.pageModel.searchRequestParams.selectedMealIds?.split(',') ?? null;
}
